import { createStore } from 'redux/store';

export const store = createStore();
